<div class="server-status-banner" *ngIf="connectionLost$ | async">
  Server connection is lost. Please try again in a moment.
</div>
<router-outlet></router-outlet>
